import React from "react";
import RequestDetailModal from "./RequestDetailModal";

const CustomsRebateModal = (props) => <RequestDetailModal {...props} />;

export default CustomsRebateModal;
